module.exports = __webpack_public_path__ + "img/eye.ad24f2c7.svg";